// 👇 Unchanged imports
import React, { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Avatar,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Chip,
  Divider,
  TextField,
  Autocomplete,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { getSocialPlatforms } from "../../../utils/socialPlatForms";
import { formatStatArray } from "../../../utils/statFormatters";
import { formatAgeGroups } from "../../../utils/AgeFormatter";
import axiosMain from "../../http/axiosMain";
import {
  formatNumberWithSuffix,
  showErrorToast,
} from "../../../utils/functions";

// 🔁 Stat row renderer (same)
const renderStatRow = (label, value) => (
  <Box
    key={label}
    display="flex"
    justifyContent="space-between"
    py={1}
    borderBottom="1px solid #e0e0e0"
  >
    <Typography variant="caption" color="text.secondary" fontWeight="bold">
      {label}
    </Typography>
    <Typography variant="body2">{value || "N/A"}</Typography>
  </Box>
);

const InfluencerCompareModal = ({ open, onClose, details }) => {
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [socialImages, setSocialImages] = useState([]);
  const [influencers, setInfluencers] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loadingInfluencers, setLoadingInfluencers] = useState(false);
  const [selectedInfluencer2, setSelectedInfluencer2] = useState(null);
  const [socialImages2, setSocialImages2] = useState([]);

  const fetchInfluencers = async (searchTerm = "") => {
    setLoadingInfluencers(true);
    try {
      const url = `/api/influencer/influencer-list?${
        searchTerm ? `search=${searchTerm}` : ""
      }`;
      const response = await axiosMain.get(url);
      console.log("resp...", response);

      if (Array.isArray(response.data?.data?.influencers)) {
        setInfluencers(response.data?.data?.influencers);
      } else {
        setInfluencers([]);
      }
    } catch (err) {
      console.error("Error fetching influencers:", err);
      setInfluencers([]);
    } finally {
      setLoadingInfluencers(false);
    }
  };

  useEffect(() => {
    if (showSearchBar) fetchInfluencers(searchTerm);
  }, [showSearchBar, searchTerm]);

  useEffect(() => {
    const fetchImages = async (influencer, setImages) => {
      const imgs = [];
      for (const [platform, handle] of Object.entries(
        influencer?.socialLinks || {}
      )) {
        console.log("...", platform, "...", handle);
        const img = await getSocialPlatforms(platform, handle);
        imgs.push({ platform, profileImageUrl: img });
        console.log(`influencer${influencer?.user_id}`, img);
      }
      setImages(imgs);
    };

    if (open) {
      fetchImages(details, setSocialImages);
      if (selectedInfluencer2)
        fetchImages(selectedInfluencer2, setSocialImages2);
    }
  }, [open, details, selectedInfluencer2]);

  const renderInfluencerCard = (inf, socialImagesList) => {
    // console.log("inf...", inf);
    const name = `${inf?.first_name || ""} ${inf?.last_name || ""}`.trim();
    // const category = inf?.category?.map((c) => c.name).join(", ") || "N/A";
    const category =
      Array.isArray(inf?.category) && inf.category.length > 0
        ? inf?.category[0]?.name
        : "N/A";
    // console.log("category", category);

    const city = inf?.city || "";
    const state = inf?.state || "";
    const location = [city, state].filter(Boolean).join(", ");
    const languages = inf?.languages?.join(", ") || "N/A";

    return (
      <>
        {renderStatRow("Category/Niche", category)}
        {renderStatRow("Location", location)}
        {renderStatRow("Language(s)", languages)}
        <Box display="flex" justifyContent="space-between" py={1}>
          <Typography
            variant="caption"
            color="text.secondary"
            fontWeight="bold"
          >
            Presence in Social Media
          </Typography>
          <Box display="flex" gap={1}>
            {socialImagesList.map(({ platform, profileImageUrl }) => (
              <Avatar
                key={platform}
                src={profileImageUrl}
                sx={{ width: 30, height: 30 }}
              />
            ))}
          </Box>
        </Box>
      </>
    );
  };
  const renderInstagramStats = (stats = {}) => {
    return (
      <>
        {renderStatRow(
          "FOLLOWERS",
          formatNumberWithSuffix(stats.followers) ?? "N/A"
        )}
        {renderStatRow("REACH", formatNumberWithSuffix(stats.reach) ?? "N/A")}
        {renderStatRow(
          "ENGAGEMENT",
          ((stats.engagement ? (stats.engagement * 100).toFixed(2) : null) ??
            "N/A") + "%"
        )}

        {renderStatRow(
          "AVG LIKES",
          formatNumberWithSuffix(stats.avg_likes) ?? "N/A"
        )}
        {renderStatRow("AVG COMMENTS", stats.avg_comments ?? "N/A")}
        {renderStatRow("AVG SHARES", stats.avg_shares ?? "N/A")}
        {renderStatRow(
          "TOP CITY OF AUDIENCE",
          stats?.top_cities && stats?.top_cities.length > 0
            ? stats?.top_cities[0].name
            : "N/A"
        )}

        {renderStatRow(
          "TOP AUDIENCE GENDER",
          stats.male_followers != null && stats.female_followers != null
            ? stats.male_followers > stats.female_followers
              ? "Male"
              : "Female"
            : "N/A"
        )}

        {renderStatRow(
          "TOP AGE GROUP OF AUDIENCE",
          formatAgeGroups(stats.age_groups)
        )}
      </>
    );
  };

  const renderYouTubeStats = (stats) => (
    <>
      {renderStatRow("SUBSCRIBERS", stats.subscribers)}
      {renderStatRow("TOTAL VIEWS", stats.total_views)}
      {renderStatRow("TOTAL VIDEOS", stats.total_videos)}
      {renderStatRow("TOTAL LIKES", stats.total_likes)}
      {renderStatRow("TOTAL COMMENTS", stats.total_comments)}
    </>
  );

  const [inputValue, setInputValue] = React.useState("");
  const [value, setValue] = React.useState(null);

  const filteredInfluencers = influencers.filter((inf) => {
    const fullName = `${inf.first_name} ${inf.last_name}`.toLowerCase();
    return fullName.includes(inputValue.toLowerCase());
  });

  const hendleSelectedInfluencer2 = async (selectedUserId) => {
    setLoadingInfluencers(true);
    try {
      const url = `/api/influencer/influencers/${selectedUserId}`;
      const response = await axiosMain.get(url);
      console.log("selected...resp...", response);

      if (response.data?.data) {
        setSelectedInfluencer2(response.data?.data);
        setValue(response.data?.data);
        setShowSearchBar(false);
      } else {
        setSelectedInfluencer2(null);
      }
    } catch (err) {
      console.error("Error fetching selected influencers:", err);
      setSelectedInfluencer2(null);
    } finally {
      setLoadingInfluencers(false);
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          p: 3,
          borderRadius: 2,
          boxShadow: 24,
          width: "90%",
          maxWidth: "950px",
          maxHeight: "90vh",
          overflowY: "auto",
        }}
      >
        {/* 🔽 Close button in top-right corner */}
        <CloseIcon
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 16,
            right: 16,
            color: "grey.600",
            cursor: "pointer",
            zIndex: 10,
          }}
        />
        <Typography variant="h6" textAlign="center" gutterBottom>
          Comparison of Influencers
        </Typography>
        <Grid container spacing={2} mb={3} justifyContent="flex-end">
          {[details, selectedInfluencer2].map((inf, idx) => (
            <Grid item xs={4} key={idx}>
              <Box
                sx={{
                  backgroundColor: "#f5f5f5",
                  borderRadius: 2,
                  p: 2,
                  textAlign: "center",
                  position: "relative",
                  height: "100%", // Allow the child to stretch
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center", // Center content vertically
                  alignItems: "center",
                  minHeight: 130, // Or any fixed height you prefer
                }}
              >
                <Avatar
                  src={inf?.profile || "/api/placeholder/64/64"}
                  sx={{ width: 64, height: 64, mb: 1 }}
                />
                <Typography fontWeight="bold" variant="body1">
                  {(inf?.first_name || "") + " " + (inf?.last_name || "") ||
                    "N/A"}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {inf?.category?.map((c) => c.name).join(", ") || "N/A"}
                </Typography>
              </Box>
            </Grid>
          ))}

          <Grid item xs={4}>
            <Box
              sx={{
                backgroundColor: "#fff",
                border: "1px dashed #ccc",
                borderRadius: 2,
                p: 2,
                textAlign: "center",
                height: "100px",
              }}
            >
              {!showSearchBar ? (
                <Button
                  size="small"
                  variant="text"
                  onClick={() => setShowSearchBar(true)}
                >
                  + Add Influencer
                </Button>
              ) : (
                <>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Search Influencer"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    sx={{
                      mb: 2,
                      height: "48px", // Custom overall height (optional)
                      "& .MuiOutlinedInput-root": {
                        height: "40px", // Set the input box height
                        paddingRight: 0,
                        "& input": {
                          height: "40px",
                          padding: "10px 14px", // Controls vertical spacing of the text
                          boxSizing: "border-box",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#ccc",
                        },
                      },
                    }}
                  />

                  <Box
                    sx={{
                      maxHeight: 200,
                      overflowY: "scroll",
                      textAlign: "left",
                      position: "relative", // Added
                      zIndex: 2,
                      background: "white",
                      border: "1px solid rgba(221, 221, 221, 1)",
                    }}
                  >
                    {loadingInfluencers ? (
                      <Typography variant="body2" color="text.secondary">
                        Loading...
                      </Typography>
                    ) : filteredInfluencers.length === 0 ? (
                      <Typography variant="body2" color="text.secondary">
                        No influencers found.
                      </Typography>
                    ) : (
                      filteredInfluencers.map((option) => (
                        <Box
                          key={option.user_id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            padding: "8px 0",
                            borderBottom: "1px solid #eee",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            if (option.user_id === details?.user_id) {
                              showErrorToast(
                                "You cannot compare the same influencer."
                              );
                              return;
                            }

                            if (
                              selectedInfluencer2 &&
                              option.user_id === selectedInfluencer2?.user_id
                            ) {
                              showErrorToast(
                                "This influencer is already selected."
                              );
                              return;
                            }

                            hendleSelectedInfluencer2(option.user_id);
                          }}
                        >
                          <Avatar
                            src={option.profile}
                            sx={{ width: 40, height: 40 }}
                          />
                          <Box>
                            <Typography fontWeight="bold">
                              {option.first_name} {option.last_name}
                            </Typography>
                            <Typography
                              variant="caption"
                              color="text.secondary"
                            >
                              {option.category?.map((c) => c.name).join(", ") ||
                                "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                      ))
                    )}
                  </Box>
                </>
              )}
            </Box>
          </Grid>
        </Grid>
        <Accordion
          defaultExpanded
          sx={{
            border: "1px solid rgba(221, 221, 221, 1)",
            boxShadow: 0,
            borderRadius: "4px",
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography fontWeight="medium">Basic Details</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box sx={{ display: "flex", width: "100%" }}>
              <Box sx={{ flex: 1, pr: 2 }}>
                {renderInfluencerCard(details, socialImages)}
              </Box>

              {/* Vertical Divider */}
              <Box
                sx={{
                  width: "1px",
                  backgroundColor: "#ddd",
                  mx: 2,
                }}
              />

              <Box sx={{ flex: 1, pl: 2 }}>
                {selectedInfluencer2 ? (
                  renderInfluencerCard(selectedInfluencer2, socialImages2)
                ) : (
                  <Typography variant="body2" color="text.secondary">
                    Coming soon...
                  </Typography>
                )}
              </Box>
            </Box>
          </AccordionDetails>
        </Accordion>
        {selectedInfluencer2 !== null &&
          (details?.instagram_stats || selectedInfluencer2?.instagram_stats ? (
            <Accordion
              defaultExpanded
              sx={{
                border: "1px solid rgba(221, 221, 221, 1)",
                borderRadius: "4px",
                boxShadow: 0,
                mt: "5px",
                "&:before": {
                  display: "none",
                },
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Chip
                  label="IG"
                  size="small"
                  sx={{ bgcolor: "pink", color: "white", mr: 1 }}
                />
                <Typography fontWeight="medium">Instagram Overview</Typography>
              </AccordionSummary>

              <AccordionDetails>
                <Box sx={{ display: "flex", width: "100%" }}>
                  {/* Left section */}
                  <Box sx={{ flex: 1, pr: 2 }}>
                    {details?.instagram_stats &&
                      renderInstagramStats(details.instagram_stats)}
                  </Box>

                  {/* Vertical divider */}
                  <Box
                    sx={{
                      width: "1px",
                      backgroundColor: "#ddd",
                      mx: 2,
                    }}
                  />

                  {/* Right section */}
                  <Box sx={{ flex: 1, pl: 2 }}>
                    {selectedInfluencer2?.instagram_stats ? (
                      renderInstagramStats(selectedInfluencer2.instagram_stats)
                    ) : (
                      <Typography variant="body2" color="text.secondary">
                        Coming soon...
                      </Typography>
                    )}
                  </Box>
                </Box>
              </AccordionDetails>
            </Accordion>
          ) : null)}

        {details?.youtube_stats || selectedInfluencer2?.youtube_stats ? (
          <Accordion
            sx={{
              border: "1px solid rgba(221, 221, 221, 1)",
              borderRadius: "4px",
              boxShadow: 0,
              mt: "5px",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Chip
                label="YT"
                size="small"
                sx={{ bgcolor: "red", color: "white", mr: 1 }}
              />
              <Typography fontWeight="medium">YouTube Overview</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ display: "flex", width: "100%" }}>
                {/* Left influencer */}
                <Box sx={{ flex: 1, pr: 2 }}>
                  {details?.youtube_stats &&
                    renderYouTubeStats(details.youtube_stats)}
                </Box>

                {/* Vertical divider */}
                <Box
                  sx={{
                    width: "1px",
                    backgroundColor: "#ddd",
                    mx: 2,
                  }}
                />

                {/* Right influencer */}
                <Box sx={{ flex: 1, pl: 2 }}>
                  {selectedInfluencer2?.youtube_stats ? (
                    renderYouTubeStats(selectedInfluencer2.youtube_stats)
                  ) : (
                    <Typography variant="body2" color="text.secondary">
                      Coming soon...
                    </Typography>
                  )}
                </Box>
              </Box>
            </AccordionDetails>
          </Accordion>
        ) : null}
        <Divider sx={{ my: 2 }} />
      </Box>
    </Modal>
  );
};

export default InfluencerCompareModal;
